//
//
//
//
//
//
//
//
//

var script = {
  props: {
    id: {
      type: String,
      required: true
    }
  }
};
export { script as default };